var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67486 0.566037C8.00694 0.884694 8.01782 1.41222 7.69917 1.7443L3.42954 6.19377H15.6669C16.1272 6.19377 16.5003 6.56686 16.5003 7.0271C16.5003 7.48734 16.1272 7.86043 15.6669 7.86043H3.4803L7.69917 12.257C8.01782 12.5891 8.00694 13.1166 7.67486 13.4353C7.34279 13.7539 6.81526 13.743 6.4966 13.411L0.899044 7.57763C0.589642 7.2552 0.589642 6.74611 0.899044 6.42367L6.4966 0.59034C6.81526 0.258261 7.34279 0.24738 7.67486 0.566037Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.8c9f57b75fe3905c20d5c17e66f5c294.svg";
export { ForwardRef as ReactComponent };